import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class LanguageGuard implements CanActivate {
  private validLanguages = ['en', 'ja', 'pt'];

  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const lang = route.paramMap.get('lang');

    if (lang && this.validLanguages.includes(lang)) {
      return true;
    }

    // If invalid language, redirect to root
    this.router.navigate(['/']);
    return false;
  }
}
